import { Button, Icon } from '@innovationnorway/cl-react';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSivaBudgetDetailsList } from '../../hooks/use-siva-budget-details-list';

type Props = {
  budgetId: string;
};
const BudgetDownloadButton: React.FC<Props> = ({ budgetId }) => {
  const { t: tSiva } = useTranslation('siva');
  const { mutations } = useSivaBudgetDetailsList(undefined);
  return (
    <Button
      type="button"
      icon
      variant="tertiary"
      aria-label={tSiva('budget.download')}
      onClick={async () => await mutations.download.mutateAsync(budgetId)}
      disabled={mutations.download.isLoading}
      className={classNames({
        'animation--spin': mutations.download.isLoading,
      })}
    >
      <Icon prefix="fasr" iconName={mutations.download.isLoading ? 'spinner' : 'arrow-to-bottom'} />
    </Button>
  );
};
export default BudgetDownloadButton;
